import lodash from 'lodash';

export function buildSidebarActions(binder, location, canSeeUnfiledDocuments) {
    let folders = lodash.cloneDeep(lodash.get(binder, 'layout.folders', []));

    if(!Array.isArray(folders) || folders.length === 0) {
        return [];
    }

    const rootFolder = lodash.remove(folders, (f) => f.parentId === null)[0];
    const folderTree = buildFolderTree(rootFolder, folders);
    const linkTree = buildLinkTree(folderTree, location, true);
    const links = [];
    links.push(linkTree);

    for(let i = 0; i < linkTree.children.length; i++) {
        links.push(linkTree.children[i]);
    }

    links[0].children.splice(0, links[0].children.length);

    canSeeUnfiledDocuments && links.unshift(buildLink({
        id: 'unfiled',
        displayName: 'Unfiled Documents',
        description: 'Contains all files that have not yet been indexed.',
        kind: 'unfiledDocuments',
        fileCount: binder.countUnfiledDocuments
    }, location));

    return links;
}

function buildLink({ id, displayName, description, kind, fileCount, options }, location, isRoot) {
    const defaultAction = lodash.merge({}, lodash.omit(location, 'query.q'), { query: { folder: id, offset: 0 } });
    const defaultSortOptions = lodash.get(options, 'sort', []);
    const action = lodash.isEmpty(defaultSortOptions) ? defaultAction :
        lodash.merge(defaultAction,{ query: { o: lodash.head(defaultSortOptions).direction === 'ascending' ? '1' : '-1'}});
    return {
        id: id,
        isRoot,
        label: displayName,
        action,
        tooltip: description,
        kind: kind,
        fileCount,
        children: []
    };
}

function buildFolderTree(folder, remainingFolders) {
    if(lodash.isNil(folder.children)){
        folder.children = [];
    }

    let children = lodash.remove(remainingFolders, (f) => f.parentId === folder.id);
    children = lodash.sortBy(children, 'displayOrder');

    for(let i = 0; i < children.length; i++){
        let subFolder = buildFolderTree(children[i], remainingFolders);
        folder.children.push(subFolder);
    }

    return folder;
}

function buildLinkTree(folderTree, location, isRoot) {
    let link = buildLink(folderTree, location, isRoot);
    link.expanded = link.id === location.query.folder;

    for(let i = 0; i < folderTree.children.length; i++){
        const child = buildLinkTree(folderTree.children[i], location, false);
        link.children.push(child);
        link.expanded = link.expanded || child.expanded;
    }

    return link;
}
